import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useEffect, useState } from "react";
import axios from "axios";


function UploadCSV(props) {
    let [isOpen, setIsOpen] = useState(false);

    //add new
    function closeModal() {
        window.location.reload();
        setIsOpen(false);
    }

    function openModal() {
        setIsOpen(true);
    }

    const [selectedFile, setSelectedFile] = useState(null);

    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
    };

    const handleUpload = async () => {
        if (!selectedFile) {
            alert("Please select a CSV file");
            return;
        }
        if (!selectedFile.name.toLowerCase().endsWith('.csv')) {
            alert("Only CSV files are allowed");
            return;
        }

        const formData = new FormData();
        formData.append('csvFile', selectedFile);

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}inventoryManagement/upload-csv`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("apEnergyAdminToken")}`
                    },
                }
            );
            const { success, message, data } = response.data || {};
            const detail = data ? ` (${data.successful || 0} processed, ${data.errors || 0} errors)` : '';
            alert(success ? `${message || 'Data Uploaded Successfully'}${detail}` : message || 'Upload failed');
            setIsOpen(false);
            if (success) closeModal();
        } catch (error) {
            console.error(error);
            const errMsg = error.response?.data?.message || error.message || 'Something went wrong';
            alert(errMsg);
            setIsOpen(false);
        }
    }
    return (
        <>
            <div className="">
                <button
                    type="button"
                    onClick={openModal}
                    className="bg-teal-600 border-teal-600 hover:bg-teal-700 hover:border-teal-700 rounded-md text-white px-4 py-2 font-medium w-35"
                >
                   Upload CSV
                </button>
            </div>

            <Transition appear show={isOpen} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={closeModal}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black bg-opacity-25" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                                    <Dialog.Title
                                        as="h3"
                                        className="text-lg font-medium leading-6 text-gray-900"
                                    >
                                        Upload CSV
                                    </Dialog.Title>
                                    <div className="mt-2">
                                        <div class="grid gap-6 mb-6 lg:grid-cols-2">
                                            <div>
                                                <label
                                                    for="name"
                                                    class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                                                >
                                                    Upload CSV
                                                </label>
                                                <input
                                                    type="file"
                                                    id="name"
                                                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg  block w-full p-2.5 "
                                                    onChange={handleFileChange}
                                                />
                                            </div>
                                        </div>
                                        <button
                                            type="submit"
                                            className="inline-flex justify-center rounded-md border border-transparent bg-teal-600 px-4 py-2 text-sm font-medium text-white"
                                            // onClick={closeModal}
                                            onClick={handleUpload}
                                        >
                                            Add
                                        </button>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </>
    );
}

export default UploadCSV;